var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.706,
    height: 15.6,
    viewBox: "0 0 16.706 15.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8775"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.626 9.563 7.424-7.424 2.516 2.516-7.424 7.424H4.626zm11.89-6.858L15.29 3.932l-2.517-2.516L14 .189a.684.684 0 0 1 .944 0l1.572 1.573a.64.64 0 0 1 .189.472.64.64 0 0 1-.189.472z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6446",
    d: "M-7.188 13H-16v12.651h13.421v-7.283",
    transform: "translate(16.6 -10.651)",
    style: {
      fill: "none",
      stroke: "#29302e",
      strokeLinejoin: "round",
      strokeWidth: "1.2px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownEdit);
export default __webpack_public_path__ + "static/media/dropdownEdit.b8458251be984b6ab4f662dcf7aac27c.svg";
export { ForwardRef as ReactComponent };